export const getToken = () => {
  return localStorage.getItem('auth_token');
};

export const setToken = (token) => {
  localStorage.setItem('auth_token', token);
};

export const removeToken = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user');
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const getErrorMessage = (error) => {
  if (!error.response) return 'Network error. Please check your connection and try again.';
  
  const status = error.response.status;
  
  // Cloudflare / server-down errors
  if ([520, 521, 522, 524].includes(status)) {
    return 'Server is temporarily unavailable. Please wait a moment and try again.';
  }
  if ([502, 503, 504].includes(status)) {
    return 'Server is restarting. Please try again in a few seconds.';
  }
  
  const data = error.response.data;
  
  // Handle Pydantic validation errors
  if (Array.isArray(data)) {
    const firstError = data[0];
    if (firstError.loc && firstError.loc.includes('email')) {
      return 'Please enter a valid email address';
    }
    return firstError.msg || 'Invalid input. Please check your data.';
  }
  
  // Handle FastAPI detail errors
  if (data.detail) {
    return typeof data.detail === 'string' ? data.detail : 'Invalid request';
  }
  
  return 'An error occurred. Please try again.';
};